import z from "zod/v4";
import { TenantIdCodec } from "@visioni/a3s-schema/codecs";
import { RealmIdCodec } from "@visioni/a3s-realms/codecs";
import { TenantScope } from "@visioni/a3s-provisioning/schema";
import { UserIdSchema } from "@visioni/a3s-users";

export const BasePath = "/api/v1";

const RealmInfo = z.object({
  id: RealmIdCodec,
  fqdn: z.string(),
  api: z.url(),
  app: z.url(),
});

const TenantInfo = z.object({
  id: TenantIdCodec,
  realm: RealmInfo,
  scopes: z.array(TenantScope).readonly(),
});

export const API = {
  me: {
    tenants: {
      Response: z.object({
        tenants: z.array(TenantInfo),
      }),
      Path: BasePath + "/me/tenants",
    },
    identity: {
      Response: z.object({
        /**
         * Resolved a3s user id. Always a Vision Auth user id.
         */
        userId: UserIdSchema,
        /**
         * Legacy (Django) user id, if the caller's a3s user has a linked
         * legacy user. Absent for pure Vision Auth users with no legacy link.
         */
        legacyUserId: UserIdSchema.optional(),
      }),
      Path: BasePath + "/me/identity",
    },
  },
  /**
   * Public deep-link redirect surface. Accepts a stable query-parameter
   * contract and 302s to an internal a3s-app URL. The path lives outside
   * `/api/v1` because it is unauthenticated and routed directly from
   * CloudFront to a dedicated Lambda function URL — see the dig CDK
   * construct for the wiring.
   */
  dig: {
    Path: "/dig",
  },
} as const;
